import React from 'react';
import { t } from 'ttag';
import style from './defaultHeader.scss';


// Components
import CaravanPrice from '../caravan/caravanPrice/caravanPriceComponent';
import CaravanWeight from '../caravan/caravanWeight/caravanWeightComponent';
import CaravanOutsideImage from '../caravan/caravanImage/caravanOutsideImageComponent';
import CaravanModel from '../caravan/caravanModel/caravanModelComponent';
import LoadConfiguration from '../header/loadConfigurationComponent';

export default function DefaultHeader() {

    return (
        <div className={style.container}>
            <div className={style.carModel}>
                <h2>{t`Sie konfigurieren`} <br /> {t`ihren neuen La Strada`}</h2>
                <CaravanModel />
            </div>
            <div className={style.carImage}>
                <CaravanOutsideImage />
            </div>
            <div className={style.data}>
                <CaravanPrice />
                <CaravanWeight />
                <LoadConfiguration />
            </div>
        </div>
    );
}
